import React from 'react';
import { ArrowUpRight, Loader2, CheckCircle2, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { useContactForm } from '../hooks/useContactForm';

const fields = [
  { name: 'name', label: 'Nome', placeholder: 'Seu nome completo', type: 'text', autoComplete: 'name', maxLength: 100 },
  { name: 'email', label: 'E-mail', placeholder: 'voce@exemplo.com.br', type: 'email', autoComplete: 'email', maxLength: 254 },
  { name: 'phone', label: 'Telefone com DDD', placeholder: '(17) 99999-9999', type: 'tel', autoComplete: 'tel-national', maxLength: 20 },
  { name: 'message', label: 'Como podemos ajudar?', placeholder: 'Conte sobre seu espaço e a solução que procura…', maxLength: 1000 },
];

export const ContactForm = () => {
  const { values, errors, status, feedback, onChange, onSubmit } = useContactForm();
  const loading = status === 'loading';
  return (
    <form className="contact-form" onSubmit={onSubmit} noValidate aria-busy={loading} data-testid="contact-form">
      <h3 data-testid="contact-form-title">Vamos tirar seu projeto do papel?</h3>
      <p className="form-intro">Envie sua mensagem. Nossa equipe entrará em contato.</p>
      <fieldset disabled={loading} className="form-fields">
        <legend className="sr-only">Dados de contato — todos os campos são obrigatórios</legend>
        {fields.map(({ name, label, ...attributes }) => {
          const Component = name === 'message' ? Textarea : Input;
          return <div className={`form-field field-${name}`} key={name}>
            <label htmlFor={`contact-${name}`} data-testid={`label-${name}`}>{label} <span aria-hidden="true">*</span></label>
            <Component {...attributes} id={`contact-${name}`} name={name} value={values[name]} onChange={onChange}
              required rows={name === 'message' ? 4 : undefined} aria-invalid={Boolean(errors[name])}
              aria-describedby={errors[name] ? `error-${name}` : undefined} data-testid={`contact-${name}`} className="fatt-input" />
            {errors[name] && <p className="field-error" id={`error-${name}`} data-testid={`error-${name}`}>{errors[name]}</p>}
          </div>;
        })}
      </fieldset>
      {feedback && <div className={`form-feedback ${status}`} role={status === 'success' ? 'status' : 'alert'} aria-live="polite" data-testid="contact-feedback">
        {status === 'success' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}<p>{feedback}</p>
      </div>}
      <Button type="submit" disabled={loading} className="fatt-button button-red form-submit" data-testid="contact-submit">
        {loading ? <><Loader2 className="animate-spin" size={18} /> Enviando mensagem…</> : <>Enviar mensagem <ArrowUpRight size={18} /></>}
      </Button>
      <p className="form-privacy" data-testid="contact-privacy">Seus dados serão utilizados para responder à sua solicitação.</p>
    </form>
  );
};